module.exports = __webpack_public_path__ + "img/button_unlocked_document.db8a17e4.svg";